export const diaChiNhanHang = {
  sections: {
    list: { title: 'Thông tin giao hàng' },
  },
  fields: {
    customerId: 'Mã khách hàng',
    customer: 'Khách hàng',
    receiverName: 'Người nhận hàng',
    phone: 'SĐT người nhận',
    address: 'Địa chỉ giao hàng',
    region: 'Phường / Tỉnh',
    province: 'Tỉnh/Thành',
    ward: 'Phường/Xã',
    viDo: 'Vĩ độ',
    kinhDo: 'Kinh độ',
    coords: 'Tọa độ GPS',
    coordsFormat: 'Vĩ độ: {viDo} · Kinh độ: {kinhDo}',
    default: 'Mặc định giao hàng',
    defaultYes: 'Mặc định',
    defaultNo: '—',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  filter: {
    searchPlaceholder: 'Người nhận, SĐT hoặc địa chỉ giao hàng',
    customerPlaceholder: 'Tìm khách hàng…',
    defaultAll: 'Tất cả',
    defaultYes: 'Chỉ mặc định',
    defaultNo: 'Không mặc định',
  },
  placeholders: {
    provinceEmpty: '— Chọn Tỉnh/Thành —',
    wardEmpty: '— Chọn Phường/Xã —',
    addressSearch: 'Gõ địa chỉ hoặc dán link Maps / tọa độ từ Zalo',
    addressNoOptions: 'Không có gợi ý địa chỉ',
    viDo: 'VD: 10.7769',
    kinhDo: 'VD: 106.7009',
  },
  titles: { add: 'Thêm thông tin giao hàng', edit: 'Sửa thông tin giao hàng' },
  inline: {
    itemTitle: 'Thông tin giao hàng',
  },
  messages: {
    noData: 'Không có dữ liệu',
    loadError: 'Không tải được dữ liệu',
    invalidContext: 'Thiếu mã khách hàng hợp lệ trên URL.',
    customerRequired: 'Vui lòng chọn khách hàng.',
    createSuccess: 'Đã tạo thông tin giao hàng',
    updateSuccess: 'Đã cập nhật thông tin giao hàng',
    deleteSuccess: 'Đã xóa thông tin giao hàng',
    notFound: 'Không tìm thấy thông tin giao hàng',
    confirmDelete: 'Xóa thông tin giao hàng «{name}»?',
    listSummary: 'Tổng số {count} thông tin giao hàng',
  },
}
